import get from 'lodash/get';

interface Area {
    headline: string;
    sub_headline: string;
    items: {
        type: string;
        headline: string;
        url: string;
    }[];
}
interface Homepage {
    [key: string]: string | Area[];
}
interface Translations {
    [key: string]: string | string[] | Translations | Homepage;
}

export type TranslatorTFunction = (
    key: string,
    interpolationValues?: Record<string, string>
) => string;

const interpolationRegexp = new RegExp('{{ *([^} ]+) *}}', 'g');

export const getTranslator = (
    translations: Translations
): TranslatorTFunction => {
    return (key, interpolationValues): string => {
        const translatedValue = get(
            translations as Record<string, unknown>,
            key
        ) as string;
        if (!interpolationValues) {
            return translatedValue;
        }

        return translatedValue
            ?.split(interpolationRegexp)
            ?.map((str, i) => (i % 2 === 0 ? str : interpolationValues[str]))
            ?.join('');
    };
};
